import { render, staticRenderFns } from "./Finish.vue?vue&type=template&id=b3e5b0da"
import script from "./Finish.vue?vue&type=script&lang=js"
export * from "./Finish.vue?vue&type=script&lang=js"
import style0 from "./Finish.vue?vue&type=style&index=0&id=b3e5b0da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports